import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { selectSymbolicTeam, showChampionshipSymbolicTeamForm } from 'modules/championship/store/championship/actions';

/**
 * Закрывает форму сборной: гасит признак «форма открыта» и снимает выбор сборной.
 *
 * Признак живёт в сторе, а не в локальном состоянии экрана, потому что вкладка
 * «Сборные» показывает по нему подпись с названием сборной и возвращает к списку
 * по клику. Из-за этого сам он при уходе с экрана не исчезает — гасить надо
 * руками, иначе возврат на вкладку снова открывает форму ранее выбранной сборной
 * (IMGM-1398).
 *
 * `championshipId` необязателен: подпись вкладки строится и до того, как
 * соревнование загрузилось. Без id колбэк ничего не делает.
 */
export const useCloseSymbolicTeamForm = (championshipId?: number) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (championshipId === undefined) {
      return;
    }

    dispatch(selectSymbolicTeam({ symbolicTeam: null, championshipId }));
    dispatch(showChampionshipSymbolicTeamForm({ state: false, championshipId }));
  }, [dispatch, championshipId]);
};
